import axios from 'axios';

export const getAllCropsForBot = () =>
  axios
    .get(`${process.env.REACT_APP_API_URL}/api/crop/allCrops`)
    .then((r) => r)
    .catch((e) => e);

export const getAllProductsForBot = () =>
  axios
    .get(`${process.env.REACT_APP_API_URL}/api/product/getProducts`)
    .then((r) => r)
    .catch((e) => e);

export const getProblemDetailForBot = (problemId) =>
  axios
    .get(`${process.env.REACT_APP_API_URL}/api/crop/problemDetail/${problemId}`)
    .then((r) => r)
    .catch((e) => e);
